class Footer {
    constructor() {
        this.newsletterFormPromise = null;
        this.newsletterModal();
    }

    newsletterModal() {
        const trigger = document.querySelector('.btnActionNewsletter');
        const modal = document.querySelector('.modal-newsletter');
        const closeButton = modal?.querySelector('.btnCloseNewsletter');

        if (!trigger || !modal || !closeButton) return;

        const open = () => {
            this.loadNewsletterForm();
            modal.classList.add('active');
            modal.removeAttribute('aria-hidden');
            modal.removeAttribute('inert');
            trigger.setAttribute('aria-expanded', 'true');
            document.body.classList.add('overflow-hidden');
            window.setTimeout(() => closeButton.focus(), 120);
        };

        const close = () => {
            modal.classList.remove('active');
            modal.setAttribute('aria-hidden', 'true');
            modal.setAttribute('inert', '');
            trigger.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('overflow-hidden');
            trigger.focus();
        };

        trigger.addEventListener('click', open);
        closeButton.addEventListener('click', close);

        modal.addEventListener('click', event => {
            if (event.target === modal) close();
        });

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && modal.classList.contains('active')) close();
        });
    }

    loadNewsletterForm() {
        if (this.newsletterFormPromise) return this.newsletterFormPromise;

        this.newsletterFormPromise = window.bmaLoadRdStationForms()
            .then(() => {
                if (typeof window.RDStationForms !== 'function') return;

                const container = document.querySelector('[id^="receba-nossos-informativos"]');
                if (!container || container.dataset.initialized === 'true') return;

                container.dataset.initialized = 'true';
                new window.RDStationForms(
                    container.id,
                    'UA-61547807-1',
                ).createForm();
                this.customizeNewsletterForm();
            })
            .catch(() => {
                this.newsletterFormPromise = null;
            });

        return this.newsletterFormPromise;
    }

    customizeNewsletterForm() {
        const container = document.querySelector('[id^="receba-nossos-informativos"]');
        if (!container) return;

        const customize = () => {
            const form = container.querySelector('form');
            if (!form || form.dataset.customized === 'true') return false;

            form.classList.add('newsletter-rd-form');

            const fields = {
                name: ['Nome', 'Informe seu nome'],
                email: ['E-mail', 'Informe seu e-mail'],
                company: ['Empresa', 'Informe o nome da empresa'],
                job_title: ['Cargo', 'Informe seu cargo'],
            };

            const usesEnglishNewsletter = ['en', 'fr'].includes(window.currentLocale?.());

            if (!usesEnglishNewsletter) {
                Object.entries(fields).forEach(([name, texts]) => {
                    const input = form.querySelector(`[name="${name}"]`);
                    const label = input?.closest('.bricks-form__field')?.querySelector('.bricks-form__label');
                    if (input) input.placeholder = texts[1];
                    if (label) label.textContent = texts[0];
                });
            }

            const topics = form.querySelector('[name^="cf_indique_o_s_tema_s_de_interesse"]');
            const topicsField = topics?.closest('.bricks-form__field');
            topicsField?.classList.add('newsletter-rd-topics');
            const topicsTitle = topicsField?.querySelector(':scope > .bricks-form__label');
            if (topicsTitle && !usesEnglishNewsletter) topicsTitle.textContent = 'Selecione o(s) assunto(s) de interesse que deseja receber';

            const allTopics = topicsField?.querySelector('input[value="Todos os temas"]');
            if (allTopics?.parentElement && !usesEnglishNewsletter) {
                allTopics.parentElement.lastChild.textContent = ' Todos';
            }

            form.dataset.customized = 'true';
            return true;
        };

        if (customize()) return;

        const observer = new MutationObserver(() => {
            if (customize()) observer.disconnect();
        });
        observer.observe(container, { childList: true, subtree: true });
    }
}

new Footer();
